import loadingImg from "../assets/robot-loader.gif";
export const tmpl = `<div class="sh-widget-container">
    <div class="sh-widget-loader">
        <img src="${loadingImg}" alt="Loading...">
    </div>
    <div class="sh-widget-tabbed-header">
        <h3><span data-element="title"></span> <button data-element="title-tooltip" data-sh-widget-tooltip="" class="sh-widget-tooltip-button white">i</button></h3>
        <p data-element="description"></p>
    </div>
    <div class="sh-widget-tab-control">
        <ul>
            <li class="sh-widget-tab-control-item"><a href="#" class="active" data-target-pane="sh-table">Ranking</a></li>
            <li class="sh-widget-tab-control-item"><a href="#" data-target-pane="sh-line">Trends</a></li>
            <li class="sh-widget-tab-control-item"><a href="#" data-target-pane="sh-chart">Share</a></li>
        </ul>
    </div>

    <div class="sh-widget-tab-content">
        <div class="sh-widget-tab-pane active" data-pane="sh-table"><div data-element="table"></div></div>
        <div class="sh-widget-tab-pane" data-pane="sh-line">
            <div class="sh-line-utility sh-widget-container sh-widget-flex">
                <div class="sh-flex-item">
                    <input type="text" class="sh-line-search" placeholder="Search...">
                </div>
                <div class="sh-flex-item sh-align-right">
                    <h4 class="sh-line-metric-options-label">Show</h4>
                    <ul class="sh-line-metric-options">
                        <li><label><input type="radio" name="{wid}-graph-metric" value="highest" data-metric-option="sh-line-show-highest" checked>Top 10</label></li>
                        <li><label><input type="radio" name="{wid}-graph-metric" value="upwards" data-metric-option="sh-line-show-upward">Upward trends</label></li>
                        <li><label><input type="radio" name="{wid}-graph-metric" value="downwards" data-metric-option="sh-line-show-downward">Downward trends</label></li>
                    </ul>
                </div>
            </div>
            <div class="sh-widget-trend-graph" data-element="graph"></div>                
        </div>
        <div class="sh-widget-tab-pane" data-pane="sh-chart">
            <div class="sh-widget-container sh-widget-flex">
                <div class="sh-flex-item">
                    <div class="sh-widget-pie-chart" data-element="pie-chart"></div>
                </div>
                <div class="sh-flex-item sh-piechart-table">
                    <div data-element="chart-table"></div>
                </div>
            </div>
        </div>
    </div>
</div>`;

export const activateTabs = function (container) {
  const tabs = container.querySelectorAll(".sh-widget-tab-control-item a");

  // click event handler
  function tabhandler(tabClickEvent) {
    tabClickEvent.preventDefault();
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove("active");
    }

    const clickedTab = tabClickEvent.currentTarget;
    clickedTab.classList.add("active");
    tabClickEvent.preventDefault();

    // target pane needs to exist to do anything
    const anchorReference = tabClickEvent.target;
    const activePaneId = anchorReference.getAttribute("data-target-pane");
    const activePane = container.querySelector(`[data-pane=${activePaneId}]`);
    if (activePane) {
      const panes = container.querySelectorAll(".sh-widget-tab-pane");
      for (let i = 0; i < panes.length; i++) {
        panes[i].classList.remove("active");
      }
      activePane.classList.add("active");

      // emit an event to listen to tab changes
      const event = new CustomEvent("tab.click", { detail: activePaneId });
      container.dispatchEvent(event);

      console.log(activePaneId);
    }
  }

  for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener("click", tabhandler);
  }
};
